"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasCheckingAccountsLoadedSuccessfully = exports.getHasACheckingAccountsFetchFinished = exports.getCheckingAccountsSlice = exports.getCheckingAccountsLastSuccess = exports.getCheckingAccountsLastError = exports.getCheckingAccountsError = exports.getCheckingAccountsData = exports.getCheckingAccounts = exports.getAreCheckingAccountsLoading = exports["default"] = exports.checkingAccounts = void 0;

var _reselect = require("reselect");

var _utils = require("@navinc/utils");

var _actions = require("./actions");

var _updatePlsUrlLoggedOut = require("../util/update-pls-url-logged-out");

var checkingAccounts = (0, _utils.createFetchReducer)({
  loadActionType: _actions.CHECKING_ACCOUNTS_LOAD,
  failureActionType: _actions.CHECKING_ACCOUNTS_FAILURE,
  successActionType: _actions.CHECKING_ACCOUNTS_SUCCESS
});
exports.checkingAccounts = checkingAccounts;

var _default = function _default(state, action) {
  switch (action.type) {
    case _actions.CHECKING_ACCOUNTS_LOAD:
    case _actions.CHECKING_ACCOUNTS_FAILURE:
    case _actions.CHECKING_ACCOUNTS_SUCCESS:
      {
        var newCheckingAccount = checkingAccounts(state.checkingAccounts, action);
        return state.checkingAccounts === newCheckingAccount ? state : {
          checkingAccounts: newCheckingAccount
        };
      }

    default:
      {
        return state;
      }
  }
};

exports["default"] = _default;

var _createBaseSelectors = (0, _utils.createBaseSelectors)('checkingAccounts'),
    getCheckingAccountsSlice = _createBaseSelectors.getSlice,
    getAreCheckingAccountsLoading = _createBaseSelectors.getIsLoading,
    getCheckingAccountsLastError = _createBaseSelectors.getLastError,
    getCheckingAccountsLastSuccess = _createBaseSelectors.getLastSuccess,
    getCheckingAccountsDataRaw = _createBaseSelectors.getData,
    getCheckingAccountsError = _createBaseSelectors.getError,
    getHasACheckingAccountsFetchFinished = _createBaseSelectors.getHasAFetchFinished,
    getHasCheckingAccountsLoadedSuccessfully = _createBaseSelectors.getHasLoadedSuccessfully;

exports.getHasCheckingAccountsLoadedSuccessfully = getHasCheckingAccountsLoadedSuccessfully;
exports.getHasACheckingAccountsFetchFinished = getHasACheckingAccountsFetchFinished;
exports.getCheckingAccountsError = getCheckingAccountsError;
exports.getCheckingAccountsLastSuccess = getCheckingAccountsLastSuccess;
exports.getCheckingAccountsLastError = getCheckingAccountsLastError;
exports.getAreCheckingAccountsLoading = getAreCheckingAccountsLoading;
exports.getCheckingAccountsSlice = getCheckingAccountsSlice;
var getCheckingAccountsData = (0, _reselect.createSelector)(getCheckingAccountsDataRaw, function (data) {
  var _data$checkingAccount;

  if (!data) {
    return data;
  }

  return Object.assign({}, data, {
    checkingAccounts: (_data$checkingAccount = data.checkingAccounts) === null || _data$checkingAccount === void 0 ? void 0 : _data$checkingAccount.map(function (checkingAccount) {
      return Object.assign({}, checkingAccount, {
        url: (0, _updatePlsUrlLoggedOut.updatePLSUrlLoggedOut)(checkingAccount.url)
      });
    })
  });
});
exports.getCheckingAccountsData = getCheckingAccountsData;
var getCheckingAccounts = (0, _reselect.createSelector)(getCheckingAccountsData, function (response) {
  var _response$checkingAcc;

  return (_response$checkingAcc = response === null || response === void 0 ? void 0 : response.checkingAccounts) !== null && _response$checkingAcc !== void 0 ? _response$checkingAcc : [];
});
exports.getCheckingAccounts = getCheckingAccounts;
//# sourceMappingURL=reducer.js.map